export enum KanbanGroup {
    Assignee,
    Label,
    Board,
}
